import React from 'react';
import { AppBar, Box, Toolbar, Typography, Button, Link as MuiLink } from '@mui/material';

import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Add your logo image to the assets folder
import { useNavigate } from 'react-router-dom';

const scrollStyle = {
  textDecoration: 'none',
  color: 'inherit',
  fontWeight: 500,
  '&:hover': { textDecoration: 'underline' },
};

const Navbar = () => {
  const navigate = useNavigate();

  const handleNavScroll = (sectionId) => {
    navigate('/', { state: { scrollTo: sectionId } });
  };
  return (
    <AppBar
    position="static"
    color="default"
    elevation={0}
    sx={{
      borderBottom: '1px solid #e0e0e0',
    }}
  >
    <Toolbar sx={{ justifyContent: 'space-between' }}>
      
      <Typography
        variant="h6"
        component={Link}
        to="/"
        sx={{ textDecoration: 'none', color: 'inherit', fontWeight: 600 }}
      >
        Pathvizor
      </Typography>


      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button href="#problem" onClick={() => handleNavScroll('problem')} sx={scrollStyle}>
            What We Do
          </Button>
          <Button href="#how" onClick={() => handleNavScroll('how')}sx={scrollStyle}>
            How It Works
          </Button>
          <Button href="#features" onClick={() => handleNavScroll('features')} sx={scrollStyle}>
            Features
          </Button>
          <Button href="#why" onClick={() => handleNavScroll('why')} sx={scrollStyle}>
            Why Us
        </Button>
        <Button component={Link} to="/about-us" color="inherit">
          About
        </Button>
        <Button component={Link} to="/privacy-policy" color="inherit">
          Privacy Policy
        </Button>
      </Box>

      {/* Login Button */}
      <Button
        component={Link}
        to="https://app.pathvizor.com/login"
        variant="contained"
        sx={{ textTransform: 'none', backgroundColor: '#1976d2' }}
      >
        Log In
      </Button>
    </Toolbar>
  </AppBar>
  );
}

export default Navbar;
